<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_28949_27559)">
      <path
        d="M17.459 13.59L11.699 6.3V0H6.29896V6.3L0.538962 13.59C-0.0910377 14.4 -0.271038 15.57 0.268962 16.47C0.718962 17.37 1.70896 18 2.69896 18H15.299C16.379 18 17.279 17.37 17.729 16.47C18.179 15.48 18.089 14.4 17.459 13.59ZM8.09896 6.84V1.8H9.89896V6.84L12.959 10.8H5.03896L8.09896 6.84ZM16.109 15.66C15.929 16.02 15.659 16.2 15.299 16.2H2.69896C2.33896 16.2 2.06896 16.02 1.88896 15.66C1.70896 15.3 1.79896 14.94 1.97896 14.67L3.59896 12.6H14.399L16.019 14.67C16.199 14.94 16.289 15.39 16.109 15.66Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_28949_27559">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Laboratory',
}
</script>
